import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {fetchJSON} from '../../../../helpers/FetchUtils';
import {
    mainHelpSuccess, mainHelpFail,
} from './actions';
import {HELP_MAIN} from "./constants";

//
function* mainHelp({payload: {params}}) {
    try {
        yield put(mainHelpSuccess({}));
        // const response = yield call(fetchJSON, '/api/help/main', {method: 'GET'});
        // if (response.success) {
        //     const responseData = response.data;
        //     let loadDatas = {...responseData};
        //     yield put(mainHelpSuccess({loadDatas}));
        // } else {
        //     yield put(mainHelpFail(response));
        // }
    } catch (error) {
        yield put(mainHelpFail({message: error.message, errorCode: '500'}));
    }
}

//
export function* mainHelpWatcher() {
    yield takeEvery(HELP_MAIN, mainHelp);
}

//
function* HelpMainSaga() {
    yield all([
        fork(mainHelpWatcher)]);
}

//
export default HelpMainSaga;
